module.exports = __webpack_public_path__ + "static/img/dialog_warning_disabled.fb00f700.png";